import { Tag } from 'antd'

export function BusinessTag({
  businessColor,
  businessName
}: {
  businessColor?: string | null
  businessName: string | null
}) {
  return <Tag color={businessColor || 'blue'}>{businessName || '未关联业务'}</Tag>
}
